import {FETCH_EDIDATA_REQUEST,FETCH_EDIDATA_SUCCESS,FETCH_EDIDATA_FAILURE} from '../actionTypes'

const intialState = {
    loading : false,
    edidata:[],
    error:''
}

const ediresponseReducer = (state = intialState, action) => {
  switch (action.type) {
    case FETCH_EDIDATA_REQUEST:
      return {
        ...state,
        loading:true
      };
    case FETCH_EDIDATA_SUCCESS :
      //alert("REDUCER"+ JSON.stringify(action.payload))
      return {
        ...state,
        loading:false,
        edidata:action.payload,
        error:''
      };
    case FETCH_EDIDATA_FAILURE:
      return {
        ...state,
        loading:false,
        ediData:[],
        error:action.payload
        
      };
    default:
      return state;
  }
};
export default ediresponseReducer;







